var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quit-wrapper" }, [
    _c("div", { staticClass: "close-area", class: { mask: _vm.mask } }),
    _vm._v(" "),
    _c("div", { staticClass: "quit-message" }, [
      _c("div", { staticClass: "message-top" }, [
        _c("div", { staticClass: "message-title" }, [
          _vm._v(_vm._s(_vm.messageTitle))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "message-cancel",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("closeQuitWarning")
              }
            }
          },
          [_c("div", { staticClass: "top-cancel" })]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-main" }, [
        _vm._v(_vm._s(_vm.messageText))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-footer" }, [
        _c(
          "button",
          {
            staticClass: "footer-cancel",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("closeQuitWarning")
              }
            }
          },
          [_vm._v("取消")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "footer-query",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$emit("eventContinue")
              }
            }
          },
          [_vm._v(_vm._s(_vm.queryBtn))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-dd010e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-dd010e50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/quitMessage.vue
// module id = null
// module chunks = 